'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var AbortController = require('abort-controller');

var anySignal = require('any-signal');

var debug = require('debug');

var errCode = require('err-code');

var log = debug('libp2p:dialer:request');
log.error = debug('libp2p:dialer:request:error');

var FIFO = require('p-fifo');

var pAny = require('p-any');

var DialRequest = /*#__PURE__*/function () {
  /**
   * Manages running the `dialAction` on multiple provided `addrs` in parallel
   * up to a maximum determined by the number of tokens returned
   * from `dialer.getTokens`. Once a DialRequest is created, it can be
   * started using `DialRequest.run(options)`. Once a single dial has succeeded,
   * all other dials in the request will be cancelled.
   * @param {object} options
   * @param {Multiaddr[]} options.addrs
   * @param {function(Multiaddr):Promise<Connection>} options.dialAction
   * @param {Dialer} options.dialer
   */
  function DialRequest(_ref) {
    var addrs = _ref.addrs,
        dialAction = _ref.dialAction,
        dialer = _ref.dialer;

    _classCallCheck(this, DialRequest);

    this.addrs = addrs;
    this.dialer = dialer;
    this.dialAction = dialAction;
  }
  /**
   * @async
   * @param {object} options
   * @param {AbortSignal} options.signal An AbortController signal
   * @returns {Connection}
   */


  _createClass(DialRequest, [{
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
        var _this = this;

        var tokens, tokenHolder, dialAbortControllers, completedDials;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tokens = this.dialer.getTokens(this.addrs.length); // If no tokens are available, throw

                if (!(tokens.length < 1)) {
                  _context2.next = 3;
                  break;
                }

                throw errCode(new Error('No dial tokens available'), 'ERR_NO_DIAL_TOKENS');

              case 3:
                tokenHolder = new FIFO();
                tokens.forEach(function (token) {
                  return tokenHolder.push(token);
                });
                dialAbortControllers = this.addrs.map(function () {
                  return new AbortController();
                });
                completedDials = 0;
                _context2.prev = 7;
                _context2.next = 10;
                return pAny(this.addrs.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(addr, i) {
                    var token, conn, signal;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return tokenHolder.shift();

                          case 2:
                            token = _context.sent;
                            _context.prev = 3;
                            signal = dialAbortControllers[i].signal;
                            _context.next = 7;
                            return _this.dialAction(addr, _objectSpread(_objectSpread({}, options), {}, {
                              signal: anySignal([signal, options.signal])
                            }));

                          case 7:
                            conn = _context.sent;
                            // Remove the successful AbortController so it is not aborted
                            dialAbortControllers.splice(i, 1);

                          case 9:
                            _context.prev = 9;
                            completedDials++; // If we have more or equal dials remaining than tokens, recycle the token, otherwise release it

                            if (_this.addrs.length - completedDials >= tokens.length) {
                              tokenHolder.push(token);
                            } else {
                              _this.dialer.releaseToken(tokens.splice(tokens.indexOf(token), 1)[0]);
                            }

                            return _context.finish(9);

                          case 13:
                            return _context.abrupt("return", conn);

                          case 14:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[3,, 9, 13]]);
                  }));

                  return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 10:
                return _context2.abrupt("return", _context2.sent);

              case 11:
                _context2.prev = 11;
                dialAbortControllers.map(function (c) {
                  return c.abort();
                }); // success/failure happened, abort everything else

                tokens.forEach(function (token) {
                  return _this.dialer.releaseToken(token);
                }); // release tokens back to the dialer

                return _context2.finish(11);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7,, 11, 15]]);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return DialRequest;
}();

module.exports.DialRequest = DialRequest;